<div class="chart-card">
  <div class="chart-header">
    <h3 class="chart-title">{{ title }}</h3>
  </div>

  <div class="chart-body">
    <div class="chart-container">
      <canvas
        baseChart
        [data]="doughnutChartData"
        [options]="doughnutChartOptions"
        [type]="'doughnut'"
      ></canvas>
    </div>

    <div class="legend">
      <div class="legend-item" *ngFor="let method of methods">
        <span class="legend-dot" [style.background-color]="method.color"></span>
        <span class="legend-label">{{ method.label }}</span>
        <span class="legend-value">{{ getPercent(method.value) }}</span>
      </div>
    </div>
  </div>
</div>

